import "core-js/modules/es.object.keys.js";
import "core-js/modules/es.symbol.js";
import "core-js/modules/es.array.filter.js";
import "core-js/modules/es.object.get-own-property-descriptor.js";
import "core-js/modules/es.array.for-each.js";
import "core-js/modules/web.dom-collections.for-each.js";
import "core-js/modules/es.object.get-own-property-descriptors.js";
import "core-js/modules/es.object.define-properties.js";
import "core-js/modules/es.object.define-property.js";
import "core-js/modules/es.array.join.js";
import "core-js/modules/es.array.find.js";
import "core-js/modules/es.date.to-string.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.to-string.js";
import "core-js/modules/es.array.concat.js";
import "core-js/modules/es.date.now.js";
import "core-js/modules/es.array.map.js";
import "core-js/modules/es.array.iterator.js";
import "core-js/modules/es.promise.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.parse-int.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.replace.js";
import "core-js/modules/es.array.slice.js";
import "core-js/modules/es.parse-float.js";
import "core-js/modules/es.number.to-fixed.js";
import "core-js/modules/es.number.constructor.js";
import _regeneratorRuntime from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/regenerator";
import _asyncToGenerator from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/asyncToGenerator";
import _classCallCheck from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/createClass";
import _defineProperty from "/home/vsts/work/1/s/dp-components/node_modules/next/node_modules/@babel/runtime/helpers/esm/defineProperty";

function ownKeys(object, enumerableOnly) {
  var keys = Object.keys(object);

  if (Object.getOwnPropertySymbols) {
    var symbols = Object.getOwnPropertySymbols(object);
    if (enumerableOnly) symbols = symbols.filter(function (sym) {
      return Object.getOwnPropertyDescriptor(object, sym).enumerable;
    });
    keys.push.apply(keys, symbols);
  }

  return keys;
}

function _objectSpread(target) {
  for (var i = 1; i < arguments.length; i++) {
    var source = arguments[i] != null ? arguments[i] : {};

    if (i % 2) {
      ownKeys(Object(source), true).forEach(function (key) {
        _defineProperty(target, key, source[key]);
      });
    } else if (Object.getOwnPropertyDescriptors) {
      Object.defineProperties(target, Object.getOwnPropertyDescriptors(source));
    } else {
      ownKeys(Object(source)).forEach(function (key) {
        Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key));
      });
    }
  }

  return target;
}

import axios from "axios";
import { CommonTypes } from "./types";
import moment from "moment-timezone";
import { DATE_CONSIDERATIONS, distanceBetweenCoordinates, formatPhoneNumber, zipDeterminer } from "@dp/common";
import { LocationTimeUIError, UIError } from "./errors";

var Restaurant = /*#__PURE__*/function () {
  function Restaurant(config, axios, common) {
    _classCallCheck(this, Restaurant);

    _defineProperty(this, "axios", void 0);

    _defineProperty(this, "config", void 0);

    _defineProperty(this, "common", void 0);

    _defineProperty(this, "transformLocationsRequest", [function (obj) {
      var str = [];

      for (var p in obj) {
        if (obj[p]) {
          str.push(encodeURIComponent(p) + "=" + encodeURIComponent(obj[p]));
        }
      }

      return str.join("&");
    }]);

    _defineProperty(this, "_processLocationSearch", function (locations) {
      var processedLocationSearchData = [];
      locations.forEach(function (location) {
        var _location$restaurantH, _location$restaurantH2, _location$restaurantH3, _location$restaurantH4, _location$contactDeta, _location$contactDeta2, _location$contactDeta3, _location$contactDeta4, _location$contactDeta5, _location$contactDeta6, _location$contactDeta7, _moment, _location$restaurantH5;

        location.isClosedToday = location === null || location === void 0 ? void 0 : (_location$restaurantH = location.restaurantHours) === null || _location$restaurantH === void 0 ? void 0 : (_location$restaurantH2 = _location$restaurantH[0]) === null || _location$restaurantH2 === void 0 ? void 0 : _location$restaurantH2.isRestaurantClosed;
        var currentDayHoursObj = location === null || location === void 0 ? void 0 : (_location$restaurantH3 = location.restaurantHours) === null || _location$restaurantH3 === void 0 ? void 0 : (_location$restaurantH4 = _location$restaurantH3[0]) === null || _location$restaurantH4 === void 0 ? void 0 : _location$restaurantH4.hoursInfo;
        var currentDayOPHours = currentDayHoursObj === null || currentDayHoursObj === void 0 ? void 0 : currentDayHoursObj.find(function (hour) {
          return (hour === null || hour === void 0 ? void 0 : hour.hourCode) === "OP";
        });
        var currentDayWLHours = currentDayHoursObj === null || currentDayHoursObj === void 0 ? void 0 : currentDayHoursObj.find(function (hour) {
          return (hour === null || hour === void 0 ? void 0 : hour.hourCode) === "WL";
        });
        location.contactDetail.address.zipCode = location.contactDetail.address.zipCode ? zipDeterminer(location === null || location === void 0 ? void 0 : (_location$contactDeta = location.contactDetail) === null || _location$contactDeta === void 0 ? void 0 : _location$contactDeta.address) : null;
        location.phoneNumber = formatPhoneNumber(location === null || location === void 0 ? void 0 : (_location$contactDeta2 = location.contactDetail) === null || _location$contactDeta2 === void 0 ? void 0 : (_location$contactDeta3 = _location$contactDeta2.phoneDetail) === null || _location$contactDeta3 === void 0 ? void 0 : (_location$contactDeta4 = _location$contactDeta3[0]) === null || _location$contactDeta4 === void 0 ? void 0 : _location$contactDeta4.phoneNumber);
        location.unFormattedPhoneNumber = location === null || location === void 0 ? void 0 : (_location$contactDeta5 = location.contactDetail) === null || _location$contactDeta5 === void 0 ? void 0 : (_location$contactDeta6 = _location$contactDeta5.phoneDetail) === null || _location$contactDeta6 === void 0 ? void 0 : (_location$contactDeta7 = _location$contactDeta6[0]) === null || _location$contactDeta7 === void 0 ? void 0 : _location$contactDeta7.phoneNumber;
        location.restaurantOpenDate = location !== null && location !== void 0 && location.restaurantOpenDate ? (_moment = moment(location === null || location === void 0 ? void 0 : location.restaurantOpenDate, DATE_CONSIDERATIONS.DATE_FORMAT)) === null || _moment === void 0 ? void 0 : _moment.format("MMMM DD") : null;
        location.currentDayOPHours = currentDayOPHours;
        location.currentDayWLHours = currentDayWLHours;
        location.hasSpecialHours = !!(location !== null && location !== void 0 && (_location$restaurantH5 = location.restaurantHours) !== null && _location$restaurantH5 !== void 0 && _location$restaurantH5.find(function (dayObj) {
          var _dayObj$hoursInfo;

          return !!(dayObj !== null && dayObj !== void 0 && (_dayObj$hoursInfo = dayObj.hoursInfo) !== null && _dayObj$hoursInfo !== void 0 && _dayObj$hoursInfo.find(function (hourObj) {
            return hourObj === null || hourObj === void 0 ? void 0 : hourObj.hasSpclHours;
          }));
        }));
        processedLocationSearchData.push(_objectSpread({}, location));
      });
      return processedLocationSearchData;
    });

    this.axios = axios;
    this.config = config;
    this.common = common;
  }

  _createClass(Restaurant, [{
    key: "_processDeliveryLocations",
    value: function () {
      var _processDeliveryLocations2 = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee(response, deliveryLocationCoordinates) {
        var _response$, _response$$data, _response$2, _response$2$data, _response$3, _response$3$data, _response$3$data$rest, _response$4, _response$4$data, _response$4$data$rest;

        var deliveryLocations, pickUpLocations, resultObj;
        return _regeneratorRuntime.wrap(function _callee$(_context) {
          while (1) {
            switch (_context.prev = _context.next) {
              case 0:
                deliveryLocations = (response === null || response === void 0 ? void 0 : (_response$ = response[0]) === null || _response$ === void 0 ? void 0 : (_response$$data = _response$.data) === null || _response$$data === void 0 ? void 0 : _response$$data.restaurants) || [];
                pickUpLocations = (response === null || response === void 0 ? void 0 : (_response$2 = response[1]) === null || _response$2 === void 0 ? void 0 : (_response$2$data = _response$2.data) === null || _response$2$data === void 0 ? void 0 : _response$2$data.restaurants) || [];
                _context.next = 4;
                return this.fetchDistancesAndDurations(deliveryLocationCoordinates, deliveryLocations);

              case 4:
                resultObj = _context.sent;
                deliveryLocations === null || deliveryLocations === void 0 ? void 0 : deliveryLocations.forEach(function (location) {
                  var _resultObj$location$r, _resultObj$location$r2;

                  location.miles = (_resultObj$location$r = resultObj[location === null || location === void 0 ? void 0 : location.restaurantNumber]) === null || _resultObj$location$r === void 0 ? void 0 : _resultObj$location$r.distance;
                  location.duration = (_resultObj$location$r2 = resultObj[location === null || location === void 0 ? void 0 : location.restaurantNumber]) === null || _resultObj$location$r2 === void 0 ? void 0 : _resultObj$location$r2.duration;
                });
                return _context.abrupt("return", {
                  deliveryLocations: deliveryLocations,
                  deliveryResultsCount: (response === null || response === void 0 ? void 0 : (_response$3 = response[0]) === null || _response$3 === void 0 ? void 0 : (_response$3$data = _response$3.data) === null || _response$3$data === void 0 ? void 0 : (_response$3$data$rest = _response$3$data.restaurants) === null || _response$3$data$rest === void 0 ? void 0 : _response$3$data$rest.length) || 0,
                  pickUpLocations: pickUpLocations,
                  pickUpResultsCount: (response === null || response === void 0 ? void 0 : (_response$4 = response[1]) === null || _response$4 === void 0 ? void 0 : (_response$4$data = _response$4.data) === null || _response$4$data === void 0 ? void 0 : (_response$4$data$rest = _response$4$data.restaurants) === null || _response$4$data$rest === void 0 ? void 0 : _response$4$data$rest.length) || 0
                });

              case 7:
              case "end":
                return _context.stop();
            }
          }
        }, _callee, this);
      }));

      function _processDeliveryLocations(_x, _x2) {
        return _processDeliveryLocations2.apply(this, arguments);
      }

      return _processDeliveryLocations;
    }()
  }, {
    key: "_processRestaurantDetails",
    value: function _processRestaurantDetails(response) {
      var _response$data, _restaurantDetails$re, _moment2, _restaurantDetails$co, _restaurantDetails$co2, _restaurantDetails$co3, _restaurantDetails$co4, _restaurantDetails$co5, _restaurantDetails$co6, _restaurantDetails$co7, _restaurantDetails$co8, _restaurantDetails$re2, _restaurantDetails$re3, _restaurantDetails$re4, _restaurantDetails$re5, _restaurantDetails$re6, _restaurantDetails$re7;

      var restaurantDetails = response === null || response === void 0 ? void 0 : (_response$data = response.data) === null || _response$data === void 0 ? void 0 : _response$data.restaurant;
      restaurantDetails.restaurantNumber = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$re = restaurantDetails.restaurantNumber) === null || _restaurantDetails$re === void 0 ? void 0 : _restaurantDetails$re.toString();
      restaurantDetails.restaurantOpenDate = restaurantDetails !== null && restaurantDetails !== void 0 && restaurantDetails.restaurantOpenDate ? (_moment2 = moment(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : restaurantDetails.restaurantOpenDate, DATE_CONSIDERATIONS.DATE_FORMAT)) === null || _moment2 === void 0 ? void 0 : _moment2.format("MMMM DD") : null;
      restaurantDetails.contactDetail.address.zipCode = restaurantDetails.contactDetail.address.zipCode ? zipDeterminer(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$co = restaurantDetails.contactDetail) === null || _restaurantDetails$co === void 0 ? void 0 : _restaurantDetails$co.address) : null;
      var address = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$co2 = restaurantDetails.contactDetail) === null || _restaurantDetails$co2 === void 0 ? void 0 : _restaurantDetails$co2.address;
      restaurantDetails.address = {
        // longitudeLatitude: string;
        stateCode: address === null || address === void 0 ? void 0 : address.stateCode,
        city: address === null || address === void 0 ? void 0 : address.city,
        country: (address === null || address === void 0 ? void 0 : address.country) || null,
        countyCode: (address === null || address === void 0 ? void 0 : address.countryCode) || null,
        state: (address === null || address === void 0 ? void 0 : address.stateCode) || null,
        address1: (address === null || address === void 0 ? void 0 : address.street1) || null,
        address2: (address === null || address === void 0 ? void 0 : address.street2) || null,
        // daylightSavingTime: boolean,
        // timeZone: string,
        countryName: address === null || address === void 0 ? void 0 : address.country,
        zipCode: address === null || address === void 0 ? void 0 : address.zipCode // cityCode: string,

      };
      restaurantDetails.phoneNumber = formatPhoneNumber(restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$co3 = restaurantDetails.contactDetail) === null || _restaurantDetails$co3 === void 0 ? void 0 : (_restaurantDetails$co4 = _restaurantDetails$co3.phoneDetail) === null || _restaurantDetails$co4 === void 0 ? void 0 : (_restaurantDetails$co5 = _restaurantDetails$co4[0]) === null || _restaurantDetails$co5 === void 0 ? void 0 : _restaurantDetails$co5.phoneNumber);
      restaurantDetails.unFormattedPhoneNumber = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$co6 = restaurantDetails.contactDetail) === null || _restaurantDetails$co6 === void 0 ? void 0 : (_restaurantDetails$co7 = _restaurantDetails$co6.phoneDetail) === null || _restaurantDetails$co7 === void 0 ? void 0 : (_restaurantDetails$co8 = _restaurantDetails$co7[0]) === null || _restaurantDetails$co8 === void 0 ? void 0 : _restaurantDetails$co8.phoneNumber;
      var operationHours = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$re2 = restaurantDetails.restaurantHours) === null || _restaurantDetails$re2 === void 0 ? void 0 : (_restaurantDetails$re3 = _restaurantDetails$re2[0]) === null || _restaurantDetails$re3 === void 0 ? void 0 : (_restaurantDetails$re4 = _restaurantDetails$re3.hoursInfo) === null || _restaurantDetails$re4 === void 0 ? void 0 : _restaurantDetails$re4.find(function (hourObj) {
        return hourObj.hourCode === "OP";
      });
      var waitlistHours = restaurantDetails === null || restaurantDetails === void 0 ? void 0 : (_restaurantDetails$re5 = restaurantDetails.restaurantHours) === null || _restaurantDetails$re5 === void 0 ? void 0 : (_restaurantDetails$re6 = _restaurantDetails$re5[0]) === null || _restaurantDetails$re6 === void 0 ? void 0 : (_restaurantDetails$re7 = _restaurantDetails$re6.hoursInfo) === null || _restaurantDetails$re7 === void 0 ? void 0 : _restaurantDetails$re7.find(function (hourObj) {
        return hourObj.hourCode === "WL";
      });
      restaurantDetails.operationalHours = {
        startTime: operationHours !== null && operationHours !== void 0 && operationHours.startTime ? operationHours === null || operationHours === void 0 ? void 0 : operationHours.startTime : null,
        endTime: operationHours !== null && operationHours !== void 0 && operationHours.endTime ? operationHours === null || operationHours === void 0 ? void 0 : operationHours.endTime : null
      };
      restaurantDetails.waitlistHours = {
        startTime: waitlistHours !== null && waitlistHours !== void 0 && waitlistHours.startTime ? waitlistHours === null || waitlistHours === void 0 ? void 0 : waitlistHours.startTime : null,
        endTime: waitlistHours !== null && waitlistHours !== void 0 && waitlistHours.endTime ? waitlistHours === null || waitlistHours === void 0 ? void 0 : waitlistHours.endTime : null
      };
      return restaurantDetails;
    }
  }, {
    key: "getRestaurantDetailsByNumber",
    value: function () {
      var _getRestaurantDetailsByNumber = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee2(restaurantNumber) {
        var _this$axios$get,
            _this$axios$get$then,
            _this = this;

        return _regeneratorRuntime.wrap(function _callee2$(_context2) {
          while (1) {
            switch (_context2.prev = _context2.next) {
              case 0:
                _context2.next = 2;
                return (_this$axios$get = this.axios.get(this.config.postfix.RESTAURANT_DETAILS, {
                  params: {
                    restaurantNumber: restaurantNumber
                  }
                })) === null || _this$axios$get === void 0 ? void 0 : (_this$axios$get$then = _this$axios$get.then(function (response) {
                  return _this._processRestaurantDetails(response);
                })) === null || _this$axios$get$then === void 0 ? void 0 : _this$axios$get$then["catch"](function (err) {
                  throw new UIError(err);
                });

              case 2:
                return _context2.abrupt("return", _context2.sent);

              case 3:
              case "end":
                return _context2.stop();
            }
          }
        }, _callee2, this);
      }));

      function getRestaurantDetailsByNumber(_x3) {
        return _getRestaurantDetailsByNumber.apply(this, arguments);
      }

      return getRestaurantDetailsByNumber;
    }()
  }, {
    key: "getAllRestaurants",
    value: function () {
      var _getAllRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee3() {
        var _this$axios$get$then2,
            _this2 = this;

        var commonQueryParams, locale;
        return _regeneratorRuntime.wrap(function _callee3$(_context3) {
          while (1) {
            switch (_context3.prev = _context3.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                return _context3.abrupt("return", (_this$axios$get$then2 = this.axios.get("".concat(this.config.postfix.SEARCH_RESTAURANT, "?locale=").concat(locale), {
                  transformRequest: this.transformLocationsRequest
                }).then(function (apiResp) {
                  var restaurants = apiResp.data.restaurants;

                  if (apiResp.status === 200 && restaurants) {
                    restaurants = _this2._processLocationSearch(restaurants);
                  }

                  return restaurants ? restaurants : null;
                })) === null || _this$axios$get$then2 === void 0 ? void 0 : _this$axios$get$then2["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 3:
              case "end":
                return _context3.stop();
            }
          }
        }, _callee3, this);
      }));

      function getAllRestaurants() {
        return _getAllRestaurants.apply(this, arguments);
      }

      return getAllRestaurants;
    }()
  }, {
    key: "searchRestaurants",
    value: function () {
      var _searchRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee4(lat, _long, resultsPerPage, radius) {
        var _this$axios$get$then3,
            _this3 = this;

        var commonQueryParams, locale, params;
        return _regeneratorRuntime.wrap(function _callee4$(_context4) {
          while (1) {
            switch (_context4.prev = _context4.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams !== null && commonQueryParams !== void 0 && commonQueryParams.locale ? commonQueryParams === null || commonQueryParams === void 0 ? void 0 : commonQueryParams.locale : "en_US";
                params = {
                  locale: locale,
                  latitude: lat,
                  longitude: _long,
                  resultsPerPage: resultsPerPage,
                  radius: radius
                };
                return _context4.abrupt("return", (_this$axios$get$then3 = this.axios.get(this.config.postfix.SEARCH_RESTAURANT, {
                  params: params,
                  transformRequest: this.transformLocationsRequest
                }).then(function (apiResp) {
                  var _apiResp$data, _apiResp$data$restaur;

                  var currTimeStamp = Date.now();
                  var restaurants = // Adding timeAtResponse parameter for RefreshAppIfNeeded implementation on regular intervals
                  (apiResp === null || apiResp === void 0 ? void 0 : (_apiResp$data = apiResp.data) === null || _apiResp$data === void 0 ? void 0 : (_apiResp$data$restaur = _apiResp$data.restaurants) === null || _apiResp$data$restaur === void 0 ? void 0 : _apiResp$data$restaur.map(function (loc) {
                    return _objectSpread(_objectSpread({}, loc), {}, {
                      timeAtResponse: currTimeStamp
                    });
                  })) || [];

                  if (apiResp.status === 200 && restaurants) {
                    restaurants = _this3._processLocationSearch(restaurants);
                  }

                  return restaurants;
                })) === null || _this$axios$get$then3 === void 0 ? void 0 : _this$axios$get$then3["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 4:
              case "end":
                return _context4.stop();
            }
          }
        }, _callee4, this);
      }));

      function searchRestaurants(_x4, _x5, _x6, _x7) {
        return _searchRestaurants.apply(this, arguments);
      }

      return searchRestaurants;
    }()
  }, {
    key: "getRestaurantWaitlistStatus",
    value: function getRestaurantWaitlistStatus(restaurant) // showFullStatus?: boolean,
    {
      var _restaurant$features;

      if (restaurant !== null && restaurant !== void 0 && (_restaurant$features = restaurant.features) !== null && _restaurant$features !== void 0 && _restaurant$features.waitListOn) {
        if (restaurant !== null && restaurant !== void 0 && restaurant.isClosedToday) {
          return "Waitlist Closed.";
        } // if (
        //   !!restaurant?.waitListInformation?.lowQuote &&
        //   !!restaurant?.waitListInformation?.highQuote
        // ) {
        // if (+restaurant?.waitListInformation?.highQuote === 0) {
        //   if (showFullStatus) {
        //     return "No Wait currently";
        //   }
        //   return "No Wait";
        // }
        // else if (restaurant?.waitListInformation?.highQuote > 60) {
        //   if (showFullStatus) {
        //     return "Est. Wait Time: 1+ hr";
        //   }
        //   return "Est. wait  1+ hr";
        // }
        // if (showFullStatus) {
        //   return `Est. Wait Time: ${restaurant?.waitListInformation?.lowQuote} - ${restaurant?.waitListInformation?.highQuote} mins`;
        // }
        // return "Waitlist Available";
        // `Est. wait ${restaurant?.waitListInformation?.lowQuote} - ${restaurant?.waitListInformation?.highQuote} mins`;
        // }


        return "Wait Time Unavailable";
      } else {
        var _restaurant$features2, _restaurant$features3;

        if (!(restaurant !== null && restaurant !== void 0 && (_restaurant$features2 = restaurant.features) !== null && _restaurant$features2 !== void 0 && _restaurant$features2.waitListEnabled)) {
          return "Waitlist Not Supported";
        } else if (!(restaurant !== null && restaurant !== void 0 && (_restaurant$features3 = restaurant.features) !== null && _restaurant$features3 !== void 0 && _restaurant$features3.waitListOn)) {
          return "Waitlist Closed";
        }

        return "Waitlist Not Supported";
      }
    }
  }, {
    key: "getRestaurantByNumbers",
    value: function () {
      var _getRestaurantByNumbers = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee5(locations) {
        var _this$axios$get$then4,
            _this4 = this;

        var params, restaurants;
        return _regeneratorRuntime.wrap(function _callee5$(_context5) {
          while (1) {
            switch (_context5.prev = _context5.next) {
              case 0:
                params = {
                  restaurantNums: locations
                };
                restaurants = [];

                if (locations !== null && locations !== void 0 && locations.length) {
                  _context5.next = 4;
                  break;
                }

                return _context5.abrupt("return", []);

              case 4:
                return _context5.abrupt("return", (_this$axios$get$then4 = this.axios.get(this.config.postfix.LIST_LOCATIONS, {
                  params: params
                }).then(function (apiResponse) {
                  var _apiResponse$data, _apiResponse$data$res;

                  var currentTimeStamp = Date.now();
                  restaurants = (apiResponse === null || apiResponse === void 0 ? void 0 : (_apiResponse$data = apiResponse.data) === null || _apiResponse$data === void 0 ? void 0 : (_apiResponse$data$res = _apiResponse$data.restaurants) === null || _apiResponse$data$res === void 0 ? void 0 : _apiResponse$data$res.map(function (loc) {
                    return _objectSpread(_objectSpread({}, loc), {}, {
                      // Adding timeAtResponse parameter for RefreshAppIfNeeded implementation on regular intervals
                      timeAtResponse: currentTimeStamp
                    });
                  })) || [];

                  if (apiResponse.status === 200 && restaurants) {
                    restaurants = _this4._processLocationSearch(restaurants);
                  }

                  return restaurants;
                })) === null || _this$axios$get$then4 === void 0 ? void 0 : _this$axios$get$then4["catch"](function (err) {
                  throw new UIError(err);
                }));

              case 5:
              case "end":
                return _context5.stop();
            }
          }
        }, _callee5, this);
      }));

      function getRestaurantByNumbers(_x8) {
        return _getRestaurantByNumbers.apply(this, arguments);
      }

      return getRestaurantByNumbers;
    }()
  }, {
    key: "checkCarsideAvailable",
    value: function () {
      var _checkCarsideAvailable = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee6(orderId, jwtToken) {
        var commonQueryParams, locale, headers;
        return _regeneratorRuntime.wrap(function _callee6$(_context6) {
          while (1) {
            switch (_context6.prev = _context6.next) {
              case 0:
                commonQueryParams = this.config.getCommonQueryParams();
                locale = commonQueryParams && commonQueryParams.locale ? commonQueryParams.locale : "en_US";
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context6.next = 6;
                return this.axios.get(this.config.postfix.CHECK_CARSIDE_AVAIL, {
                  params: {
                    locale: locale,
                    orderId: orderId
                  },
                  headers: _objectSpread(_objectSpread({}, headers), {}, {
                    "x-retry-on-timeout": true
                  })
                }).then(function (response) {
                  var _response$data2;

                  return response === null || response === void 0 ? void 0 : (_response$data2 = response.data) === null || _response$data2 === void 0 ? void 0 : _response$data2.curbSideAvailable;
                })["catch"](function (err) {
                  throw new UIError(err);
                });

              case 6:
                return _context6.abrupt("return", _context6.sent);

              case 7:
              case "end":
                return _context6.stop();
            }
          }
        }, _callee6, this);
      }));

      function checkCarsideAvailable(_x9, _x10) {
        return _checkCarsideAvailable.apply(this, arguments);
      }

      return checkCarsideAvailable;
    }()
  }, {
    key: "updateLocation",
    value: function () {
      var _updateLocation = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee7(payload, jwtToken) {
        var headers;
        return _regeneratorRuntime.wrap(function _callee7$(_context7) {
          while (1) {
            switch (_context7.prev = _context7.next) {
              case 0:
                headers = {
                  "x-retry-on-timeout": true
                };

                if (jwtToken) {
                  headers["Authorization"] = "Bearer ".concat(jwtToken);
                }

                _context7.next = 4;
                return this.axios.put(this.config.postfix.UPDATE_LOCATION, payload, {
                  headers: headers
                }).then(function (resp) {
                  var _resp$data;

                  return resp === null || resp === void 0 ? void 0 : (_resp$data = resp.data) === null || _resp$data === void 0 ? void 0 : _resp$data.response;
                })["catch"](function (err) {
                  throw new LocationTimeUIError(err);
                });

              case 4:
                return _context7.abrupt("return", _context7.sent);

              case 5:
              case "end":
                return _context7.stop();
            }
          }
        }, _callee7, this);
      }));

      function updateLocation(_x11, _x12) {
        return _updateLocation.apply(this, arguments);
      }

      return updateLocation;
    }()
  }, {
    key: "getRestaurantPDFMenuURL",
    value: function () {
      var _getRestaurantPDFMenuURL = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee8(restaurantNumber) {
        var _response$data3, response;

        return _regeneratorRuntime.wrap(function _callee8$(_context8) {
          while (1) {
            switch (_context8.prev = _context8.next) {
              case 0:
                _context8.prev = 0;
                _context8.next = 3;
                return this.axios.get(this.config.postfix.RESTAURANT_PDF_CONF);

              case 3:
                response = _context8.sent;
                return _context8.abrupt("return", this._processRestaurantPDFMenu(response === null || response === void 0 ? void 0 : (_response$data3 = response.data) === null || _response$data3 === void 0 ? void 0 : _response$data3.pdfMenuConfig, restaurantNumber));

              case 7:
                _context8.prev = 7;
                _context8.t0 = _context8["catch"](0);
                return _context8.abrupt("return", null);

              case 10:
              case "end":
                return _context8.stop();
            }
          }
        }, _callee8, this, [[0, 7]]);
      }));

      function getRestaurantPDFMenuURL(_x13) {
        return _getRestaurantPDFMenuURL.apply(this, arguments);
      }

      return getRestaurantPDFMenuURL;
    }()
  }, {
    key: "getDeliveryRestaurants",
    value: function () {
      var _getDeliveryRestaurants = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee9(deliveryLocationParams, pickupLocationParams, isTogo) {
        var response, deliveryLocationCoordinates;
        return _regeneratorRuntime.wrap(function _callee9$(_context9) {
          while (1) {
            switch (_context9.prev = _context9.next) {
              case 0:
                if (!isTogo) {
                  _context9.next = 6;
                  break;
                }

                _context9.next = 3;
                return Promise.all([this.axios.get(this.config.postfix.GET_EXTERNAL_DELIVERY_RESTAURANTS, {
                  params: {
                    latitude: deliveryLocationParams === null || deliveryLocationParams === void 0 ? void 0 : deliveryLocationParams.latitude,
                    longitude: deliveryLocationParams === null || deliveryLocationParams === void 0 ? void 0 : deliveryLocationParams.longitude
                  },
                  headers: {
                    "x-retry-on-timeout": true
                  }
                })])["catch"](function (err) {
                  throw new UIError(err);
                });

              case 3:
                _context9.t0 = _context9.sent;
                _context9.next = 9;
                break;

              case 6:
                _context9.next = 8;
                return Promise.all([this.axios.get(this.config.postfix.GET_DELIVERY_RESTAURANTS, {
                  params: deliveryLocationParams,
                  headers: {
                    "x-retry-on-timeout": true
                  }
                }), this.axios.get(this.config.postfix.SEARCH_RESTAURANT, {
                  params: pickupLocationParams,
                  transformRequest: this.transformLocationsRequest
                })])["catch"](function (err) {
                  throw new UIError(err);
                });

              case 8:
                _context9.t0 = _context9.sent;

              case 9:
                response = _context9.t0;
                deliveryLocationCoordinates = {
                  latitude: (deliveryLocationParams === null || deliveryLocationParams === void 0 ? void 0 : deliveryLocationParams.latitude) || null,
                  longitude: (deliveryLocationParams === null || deliveryLocationParams === void 0 ? void 0 : deliveryLocationParams.longitude) || null
                };
                _context9.next = 13;
                return this._processDeliveryLocations(response, deliveryLocationCoordinates);

              case 13:
                return _context9.abrupt("return", _context9.sent);

              case 14:
              case "end":
                return _context9.stop();
            }
          }
        }, _callee9, this);
      }));

      function getDeliveryRestaurants(_x14, _x15, _x16) {
        return _getDeliveryRestaurants.apply(this, arguments);
      }

      return getDeliveryRestaurants;
    }()
  }, {
    key: "setDeliveryAddress",
    value: function () {
      var _setDeliveryAddress = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee10(_ref, jwtToken) {
        var addressLine1, addressLine2, city, companyName, country, state, type, zipcode, restaurantNum, orderId, headers, data, response;
        return _regeneratorRuntime.wrap(function _callee10$(_context10) {
          while (1) {
            switch (_context10.prev = _context10.next) {
              case 0:
                addressLine1 = _ref.addressLine1, addressLine2 = _ref.addressLine2, city = _ref.city, companyName = _ref.companyName, country = _ref.country, state = _ref.state, type = _ref.type, zipcode = _ref.zipcode, restaurantNum = _ref.restaurantNum, orderId = _ref.orderId;
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                data = {
                  addressLine1: addressLine1,
                  city: city,
                  state: state,
                  zipcode: zipcode,
                  country: country,
                  type: type,
                  addressLine2: addressLine2,
                  companyName: companyName,
                  restaurantNum: restaurantNum,
                  orderId: orderId
                };
                _context10.next = 6;
                return this.axios.put(this.config.postfix.SET_DELIVERY_ADDRESS, data, {
                  headers: _objectSpread(_objectSpread({}, headers), {}, {
                    "x-retry-on-timeout": true
                  })
                });

              case 6:
                response = _context10.sent;
                return _context10.abrupt("return", response.data);

              case 8:
              case "end":
                return _context10.stop();
            }
          }
        }, _callee10, this);
      }));

      function setDeliveryAddress(_x17, _x18) {
        return _setDeliveryAddress.apply(this, arguments);
      }

      return setDeliveryAddress;
    }()
  }, {
    key: "setDeliveryTime",
    value: function () {
      var _setDeliveryTime = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee11(deliveryDate, deliveryTime, partySize, deliveryRestDuration, deliveryRestDistance, orderId, jwtToken) {
        var data, headers, response;
        return _regeneratorRuntime.wrap(function _callee11$(_context11) {
          while (1) {
            switch (_context11.prev = _context11.next) {
              case 0:
                data = {
                  deliveryDate: deliveryDate,
                  deliveryTime: deliveryTime,
                  // sending undefined will be ignored in payload and error will trigger from BE
                  partySize: partySize > 0 ? partySize : undefined,
                  deliveryRestDuration: deliveryRestDuration,
                  deliveryRestDistance: deliveryRestDistance,
                  orderId: orderId
                };
                headers = _defineProperty({}, CommonTypes.APIHeaders.Authorization, "Bearer ".concat(jwtToken));
                !jwtToken && delete headers[CommonTypes.APIHeaders.Authorization];
                _context11.next = 5;
                return this.axios.put(this.config.postfix.SET_DELIVERY_TIME, data, {
                  headers: _objectSpread(_objectSpread({}, headers), {}, {
                    "x-retry-on-timeout": true
                  })
                });

              case 5:
                response = _context11.sent;
                return _context11.abrupt("return", response.data.status);

              case 7:
              case "end":
                return _context11.stop();
            }
          }
        }, _callee11, this);
      }));

      function setDeliveryTime(_x19, _x20, _x21, _x22, _x23, _x24, _x25) {
        return _setDeliveryTime.apply(this, arguments);
      }

      return setDeliveryTime;
    }()
  }, {
    key: "getTargetersForCurrentRestaurant",
    value: function () {
      var _getTargetersForCurrentRestaurant = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee12(targeterPath, restNumber, conceptCode, channel) {
        var _response$data4;

        var response;
        return _regeneratorRuntime.wrap(function _callee12$(_context12) {
          while (1) {
            switch (_context12.prev = _context12.next) {
              case 0:
                _context12.next = 2;
                return this.axios.get(this.config.postfix.GET_TARGETERS, {
                  params: {
                    targeterPath: targeterPath,
                    restNumber: restNumber,
                    conceptCode: conceptCode,
                    channel: channel
                  }
                });

              case 2:
                response = _context12.sent;
                return _context12.abrupt("return", (_response$data4 = response.data) === null || _response$data4 === void 0 ? void 0 : _response$data4.successresponse);

              case 4:
              case "end":
                return _context12.stop();
            }
          }
        }, _callee12, this);
      }));

      function getTargetersForCurrentRestaurant(_x26, _x27, _x28, _x29) {
        return _getTargetersForCurrentRestaurant.apply(this, arguments);
      }

      return getTargetersForCurrentRestaurant;
    }()
  }, {
    key: "_processRestaurantPDFMenu",
    value: function _processRestaurantPDFMenu(pdfMenuConfig, restaurantNum) {
      var locationArr = pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.locationEnabled;
      var restMenuConfig = pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.restMenuConfig;
      var pdfMenuUrl = "";
      var isPdfMenuEnabled;

      if (restaurantNum && locationArr && restMenuConfig && locationArr.includes(parseInt(restaurantNum))) {
        if (pdfMenuConfig !== null && pdfMenuConfig !== void 0 && pdfMenuConfig.isSingleMenu) {
          var restautantFound = restMenuConfig.filter(function (item) {
            return "".concat(item === null || item === void 0 ? void 0 : item.locationNum) === "".concat(restaurantNum);
          });

          if (restautantFound.length > 0) {
            pdfMenuUrl = (pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.staticURL) + restautantFound[0].fileName;
            isPdfMenuEnabled = true;
          } else {
            isPdfMenuEnabled = false;
          }
        } else {
          isPdfMenuEnabled = true;
          pdfMenuUrl = (pdfMenuConfig === null || pdfMenuConfig === void 0 ? void 0 : pdfMenuConfig.multiMenuLandingPage) + restaurantNum;
        }
      } else {
        isPdfMenuEnabled = false;
      }

      if (isPdfMenuEnabled) {
        return pdfMenuUrl;
      }

      return null;
    }
  }, {
    key: "getRestaurantDistanceandDuration",
    value: function () {
      var _getRestaurantDistanceandDuration = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee13(longLat, curbs) {
        var _response$data5, _response$data6, response;

        return _regeneratorRuntime.wrap(function _callee13$(_context13) {
          while (1) {
            switch (_context13.prev = _context13.next) {
              case 0:
                _context13.prev = 0;
                _context13.next = 3;
                return axios.get(this.config.postfix.MAPBOX_DISTANCE_AND_DURATION.replace("{coordinates}", longLat), {
                  params: {
                    approaches: curbs,
                    access_token: "pk.eyJ1IjoiZ3JhbWFzYW15IiwiYSI6ImNrZzhlNnE4YTBnaGgyeW8ycnNwc3Z0MjUifQ.TpPjJoGYawcq6kgIwPtmFg"
                  }
                });

              case 3:
                response = _context13.sent;
                return _context13.abrupt("return", {
                  distances: (_response$data5 = response.data) === null || _response$data5 === void 0 ? void 0 : _response$data5.distances[0],
                  durations: (_response$data6 = response.data) === null || _response$data6 === void 0 ? void 0 : _response$data6.durations[0]
                });

              case 7:
                _context13.prev = 7;
                _context13.t0 = _context13["catch"](0);
                console.log("err", _context13.t0);
                return _context13.abrupt("return", {
                  distances: null,
                  durations: null
                });

              case 11:
              case "end":
                return _context13.stop();
            }
          }
        }, _callee13, this, [[0, 7]]);
      }));

      function getRestaurantDistanceandDuration(_x30, _x31) {
        return _getRestaurantDistanceandDuration.apply(this, arguments);
      }

      return getRestaurantDistanceandDuration;
    }()
  }, {
    key: "fetchDistancesAndDurations",
    value: function () {
      var _fetchDistancesAndDurations = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee14(myCoords, restSearchResults) {
        var _Object$keys, resultObj, resultsLength, start, end, noOfCall, i, obj;

        return _regeneratorRuntime.wrap(function _callee14$(_context14) {
          while (1) {
            switch (_context14.prev = _context14.next) {
              case 0:
                _context14.prev = 0;
                resultObj = {};
                resultsLength = restSearchResults.length;
                noOfCall = Math.ceil(resultsLength / 24);
                i = 0;

              case 5:
                if (!(noOfCall > i)) {
                  _context14.next = 15;
                  break;
                }

                start = 24 * i;
                end = resultsLength < 24 * (i + 1) ? resultsLength : 24 * (i + 1);
                _context14.next = 10;
                return this.fetchDistancesandDurationsAPI(myCoords, restSearchResults.slice(start, end));

              case 10:
                obj = _context14.sent;
                resultObj = _objectSpread(_objectSpread({}, resultObj), obj);
                i++;
                _context14.next = 5;
                break;

              case 15:
                if (!((Object === null || Object === void 0 ? void 0 : (_Object$keys = Object.keys(resultObj)) === null || _Object$keys === void 0 ? void 0 : _Object$keys.length) === 0)) {
                  _context14.next = 17;
                  break;
                }

                return _context14.abrupt("return", this.getLocalDistanceAndDurations(myCoords, restSearchResults));

              case 17:
                return _context14.abrupt("return", resultObj);

              case 20:
                _context14.prev = 20;
                _context14.t0 = _context14["catch"](0);
                return _context14.abrupt("return", this.getLocalDistanceAndDurations(myCoords, restSearchResults));

              case 23:
              case "end":
                return _context14.stop();
            }
          }
        }, _callee14, this, [[0, 20]]);
      }));

      function fetchDistancesAndDurations(_x32, _x33) {
        return _fetchDistancesAndDurations.apply(this, arguments);
      }

      return fetchDistancesAndDurations;
    }()
  }, {
    key: "fetchDistancesandDurationsAPI",
    value: function () {
      var _fetchDistancesandDurationsAPI = _asyncToGenerator( /*#__PURE__*/_regeneratorRuntime.mark(function _callee15(myCoords, restSearchResults) {
        var _distanceAndDurationR, _distanceAndDurationR2, tempApiStr, tempCurbStr, resultObj, distanceAndDurationResult;

        return _regeneratorRuntime.wrap(function _callee15$(_context15) {
          while (1) {
            switch (_context15.prev = _context15.next) {
              case 0:
                _context15.prev = 0;
                tempApiStr = "";
                tempCurbStr = "curb;";
                resultObj = {};
                tempApiStr += myCoords.longitude.toString() + "," + myCoords.latitude.toString() + ";";
                restSearchResults === null || restSearchResults === void 0 ? void 0 : restSearchResults.forEach(function (data, idx) {
                  tempApiStr += data.contactDetail.address.coordinates.longitude.toString() + "," + data.contactDetail.address.coordinates.latitude.toString();
                  tempCurbStr = tempCurbStr + "curb";

                  if (idx !== restSearchResults.length - 1) {
                    tempApiStr += ";";
                    tempCurbStr += ";";
                  }
                });
                _context15.next = 8;
                return this.getRestaurantDistanceandDuration(tempApiStr, tempCurbStr);

              case 8:
                distanceAndDurationResult = _context15.sent;
                distanceAndDurationResult === null || distanceAndDurationResult === void 0 ? void 0 : (_distanceAndDurationR = distanceAndDurationResult.distances) === null || _distanceAndDurationR === void 0 ? void 0 : _distanceAndDurationR.forEach(function (data, idx) {
                  if (idx > 0) {
                    var _key = restSearchResults[idx - 1].restaurantNumber;
                    var distInKms = data / 1000;
                    var distInMiles = distInKms * 0.621371;
                    resultObj[_key] = {
                      distance: distInMiles
                    };
                  }
                });
                distanceAndDurationResult === null || distanceAndDurationResult === void 0 ? void 0 : (_distanceAndDurationR2 = distanceAndDurationResult.durations) === null || _distanceAndDurationR2 === void 0 ? void 0 : _distanceAndDurationR2.forEach(function (data, idx) {
                  if (idx > 0) {
                    var _key2 = restSearchResults[idx - 1].restaurantNumber;
                    resultObj[_key2] = _objectSpread(_objectSpread({}, resultObj[_key2]), {}, {
                      duration: parseFloat("".concat((data / 60).toFixed(2)))
                    });
                  }
                });
                return _context15.abrupt("return", resultObj);

              case 14:
                _context15.prev = 14;
                _context15.t0 = _context15["catch"](0);
                return _context15.abrupt("return", {});

              case 17:
              case "end":
                return _context15.stop();
            }
          }
        }, _callee15, this, [[0, 14]]);
      }));

      function fetchDistancesandDurationsAPI(_x34, _x35) {
        return _fetchDistancesandDurationsAPI.apply(this, arguments);
      }

      return fetchDistancesandDurationsAPI;
    }()
  }, {
    key: "getLocalDistanceAndDurations",
    value: function getLocalDistanceAndDurations(myCoords, restSearchResults) {
      var resultObj = {};
      restSearchResults.forEach(function (item) {
        var _item$contactDetail, _item$contactDetail$a;

        var distance = distanceBetweenCoordinates(myCoords, item === null || item === void 0 ? void 0 : (_item$contactDetail = item.contactDetail) === null || _item$contactDetail === void 0 ? void 0 : (_item$contactDetail$a = _item$contactDetail.address) === null || _item$contactDetail$a === void 0 ? void 0 : _item$contactDetail$a.coordinates); // assuming 1 mile takes 2.5 mins

        resultObj[item.restaurantNumber] = {
          distance: distance,
          duration: Number((distance * 2.5).toFixed(2))
        };
      });
      return resultObj;
    }
  }]);

  return Restaurant;
}();

export { Restaurant as default };